import {isKit, isPickPack}  from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";

import {PersistStep}  from "./persist-step";
import {PrepareStep}  from "./prepare-step";
import {RedirectStep} from "./redirect-step";

export const XpressoCheckout = (
    {
        status,
        sku,
        item=null,

        isCCTemplate,
        prepareSave,
        customizeFlow,

        location,
        isFromApproval,
        build3Cond,
        forceBuild3,
        next: rootNext,
    }
) => cs(
    consumeContext("templateOptions"),
    ["prepareStep", ({templateOptions}, next) => PrepareStep({
        item,
        isPickPack: isPickPack(templateOptions),
        isCCTemplate: isCCTemplate ?? (templateOptions?.proofEngineType === 0),
        isKit: isKit(templateOptions),
        next,
    })],
    ["persistStep", ({}, next) => PersistStep({sku, status, prepareSave, next})],
    ["redirectStep", ({templateOptions}, next) => RedirectStep({
        status,
        isKit: isKit(templateOptions),

        customizeFlow,

        location,
        isFromApproval,
        build3Cond,
        forceBuild3,
        next,
    })],

    ({prepareStep, redirectStep, persistStep}) => rootNext(async ({user, approval, forceCustomize}) => {
        const prepared = await prepareStep({user});
        const {newItem, type} = await persistStep(prepared);
        await redirectStep({newItem, type, approval, forceCustomize, reset: prepared.reset});
    }),
);
